import { createFileRoute } from '@tanstack/react-router'

import { ProvidersProductPage } from '#/modules/intake/providers-product-page'

export const Route = createFileRoute('/_shell/providers/')({
  component: ProvidersProductPage,
})
